export default {
  tenant: {},
  contract: {},
  quit: {},
  detailView: {
    loading: true,
  },
};
